import React from 'react';
import css from './AppointmentDetails.module.css';
import {
  Accordion,
  Label,
  Paragraph,
  ProviderImage,
  StackedColumn,
  StackedColumnSpacing,
  StackedRow,
} from '../../../core';
import {
  SchedulingDetails,
  SchedulingTarget,
  formatPatientName,
} from '../../../api/models';
import { DateUtility } from '@mchs/web-core';

export interface AppointmentDetailsPresenterProps {
  schedulingDetails: SchedulingDetails;
  collapsableDetail?: boolean;
}

const AppointmentDetailsPresenter: React.FC<
  AppointmentDetailsPresenterProps
> = (props: AppointmentDetailsPresenterProps) => {
  const slotDateTime: string = props.schedulingDetails.dateTimeDetails?.slot
    ?.appointmentDateTime
    ? DateUtility.formatDateLongWeekdayLongMonthAtTime(
        props.schedulingDetails.dateTimeDetails?.slot?.appointmentDateTime
      )
    : '';
  const patientName: string = formatPatientName(
    props.schedulingDetails.patientDetails?.demographics
  );

  return (
    <div className={css.container}>
      <Accordion
        title="Appointment details"
        startExpanded={props.collapsableDetail === false ? true : false}
        collapsable={props.collapsableDetail}
      >
        <StackedColumn>
          <StackedColumn spacing={StackedColumnSpacing.NoGap}>
            <Label text="CARE PROVIDER" />
            <StackedRow>
              <div className={css.providerImageContainer}>
                <ProviderImage
                  cattailsProviderNumber={
                    props.schedulingDetails.providerDetails?.cattailsProviderId
                  }
                />
              </div>
              <StackedColumn spacing={StackedColumnSpacing.NoGap}>
                <Paragraph
                  bold={true}
                  text={props.schedulingDetails.providerDetails?.name ?? ''}
                />
                {props.schedulingDetails.locationDetails?.searchLocationName ? (
                  <Paragraph
                    text={props.schedulingDetails.locationDetails?.searchLocationName}
                  />
                ) : null}
              </StackedColumn>
            </StackedRow>
          </StackedColumn>
          {patientName.length > 0 ? (
            <StackedColumn spacing={StackedColumnSpacing.NoGap}>
              <Label text="SCHEDULING FOR" />
              <Paragraph
                text={`${formatPatientName(
                  props.schedulingDetails.patientDetails?.demographics
                )} ${
                  props.schedulingDetails.patientDetails?.target ===
                  SchedulingTarget.Myself
                    ? '(You)'
                    : ''
                }`}
              />
              <Paragraph
                text={
                  props.schedulingDetails.appointmentInfo
                    ?.appointmentTypeName ?? ''
                }
              />
              {slotDateTime.length > 0 ? (
                <Paragraph text={slotDateTime} />
              ) : null}
            </StackedColumn>
          ) : null}
        </StackedColumn>
      </Accordion>
    </div>
  );
};

export default AppointmentDetailsPresenter;
